import { StoreContext } from '../../../../lib/store';
import styles from './styles.scss';
import { useContext } from 'react';
import classNames from 'classnames';

import { Discover } from '../../../../lib/components/discover';
import { ConfirmButton } from '../../../../lib/components/confirm-button';
import { Icon } from '../../../../lib/components/icon';

import { checkIsTablet } from 'common/js/platform';
import { Component as MultiscreenCreative } from '../multiscreen-creative/component';
import { Component as OptOutIconComponent } from '../../opt-out-icon/component';

import * as React from 'react';

const borderStyle = '1px solid #666';

export function Component() {
  const store = useContext(StoreContext);
  const isViewable = store.mraidStore.mraidViewability;

  const {
    icon,
    confirmButton,
    discover,
    blurEffect,
    creative,
    interaction
  } = store.formatConfig;

  const { showOptoutLink, childPrivacyApplied } = store.adContext;
  const showOptout = showOptoutLink || childPrivacyApplied;

  const [isTablet, setIsTablet] = React.useState(checkIsTablet());

  React.useEffect(() => {
    isViewable && setIsTablet(checkIsTablet());
  }, [isViewable]);

  const showConfirmButton = !!discover?.show && !!confirmButton?.show;
  const iconInPreview =
    window.isOgyPreview && icon?.useIcon && Boolean(icon?.url);
  const showIcon =
    iconInPreview ||
    (icon?.useIcon && !!icon.url && !!icon.name && !!icon.identifier) ||
    false;
  const isFullscreen = !showIcon && !discover?.show;
  const isTabletMode = !isFullscreen && isTablet;
  const isLandscape = !store.creativeStore.isVertical;
  const isImageCreative = creative?.creative === 'Image';

  const displayBlurEffect =
    blurEffect.show &&
    isFullscreen &&
    (isImageCreative || blurEffect.image?.length > 0);

  const injectLandscapeLayout = isLandscape && !isTablet && !isFullscreen;
  const rootStyle = classNames(
    styles.rootStyle,
    injectLandscapeLayout ? styles.rootStyleRow : styles.rootStyleColumn,
    injectLandscapeLayout ? styles.landscapeLayout : styles.rootLayout
  );

  const hasDiscoverBlocks = discover.show || showConfirmButton || showIcon;

  return (
    <div
      className={rootStyle}
      onTouchStart={e => {
        interaction !== 'click' && store.userClickHandler.handle(e as any);
      }}
      onClick={e => {
        interaction === 'click' && store.userClickHandler.handle(e as any);
      }}
    >
      <div>
        {hasDiscoverBlocks &&
          (isTabletMode ? (
            <TabletLayout
              showConfirmButton={showConfirmButton}
              showIcon={showIcon}
            />
          ) : (
            <SmartphoneLayout
              showConfirmButton={showConfirmButton}
              showIcon={showIcon}
            />
          ))}
      </div>
      <div>
        <MultiscreenCreative
          isFullscreen={isFullscreen}
          isTablet={isTablet}
          displayBlurEffect={displayBlurEffect}
        />
        {showOptout && <OptOutIconComponent />}
      </div>
    </div>
  );
}

function SmartphoneLayout(props: {
  showConfirmButton: boolean;
  showIcon: boolean;
}): JSX.Element {
  const store = useContext(StoreContext);
  const isLandscape = !store.creativeStore.isVertical;

  const { discover } = store.formatConfig;

  const containerStyles = {
    borderRight: isLandscape ? borderStyle : ''
  };

  const discoverStyles = {
    borderBottom:
      isLandscape && !props.showConfirmButton && !props.showIcon
        ? ''
        : borderStyle
  };

  const confirmStyles = {
    borderBottom: isLandscape && !props.showIcon ? '' : borderStyle
  };

  const iconStyles = {
    borderBottom: isLandscape ? '' : borderStyle
  };

  return (
    <div style={containerStyles} className={styles.uiBlocks}>
      {discover.show && (
        <div
          style={discoverStyles}
          className={classNames({
            [styles.grow]: isLandscape
          })}
        >
          <Discover
            style={{
              height: isLandscape ? '100%' : discover.height
            }}
          />
        </div>
      )}
      {props.showConfirmButton && (
        <div style={confirmStyles}>
          <ConfirmButton />
        </div>
      )}
      {props.showIcon && (
        <div
          style={iconStyles}
          className={classNames({
            [styles.grow]: isLandscape && !discover.show
          })}
        >
          <Icon />
        </div>
      )}
    </div>
  );
}

function TabletLayout(props: {
  showConfirmButton: boolean;
  showIcon: boolean;
}): JSX.Element {
  const store = useContext(StoreContext);
  const { discover, icon } = store.formatConfig;

  const tabletBlockHeight = Math.max(discover.height, icon.bannerHeight || 10);
  return (
    <div className={styles.uiBlocks}>
      <div
        className={styles.tabletTopRow}
        style={{ borderBottom: borderStyle }}
      >
        {discover.show && <Discover style={{ height: tabletBlockHeight }} />}
        {props.showIcon && <Icon style={{ height: tabletBlockHeight }} />}
      </div>
      {props.showConfirmButton && (
        <div style={{ borderBottom: borderStyle }}>
          <ConfirmButton />
        </div>
      )}
    </div>
  );
}
